"use client";

import React, { createContext, useContext, useState, ReactNode } from 'react';

interface FileContextType {
  pdfFile: File | null;
  setPdfFile: (file: File | null) => void;
  pdfUrl: string | null;
  setPdfUrl: (url: string | null) => void;
  clearPdf: () => void;
}

const FileContext = createContext<FileContextType | undefined>(undefined);

export function FileProvider({ children }: { children: ReactNode }) {
  const [pdfFile, setPdfFileState] = useState<File | null>(null);
  const [pdfUrl, setPdfUrlState] = useState<string | null>(null);

  const setPdfFile = (file: File | null) => {
    // Revoke old URL if exists
    if (pdfUrl) {
      URL.revokeObjectURL(pdfUrl);
    }
    
    setPdfFileState(file);
    
    // Create new object URL if file provided
    if (file) {
      const url = URL.createObjectURL(file);
      setPdfUrlState(url);
    } else {
      setPdfUrlState(null);
    }
  };

  const setPdfUrl = (url: string | null) => {
    setPdfUrlState(url);
  };

  const clearPdf = () => {
    if (pdfUrl) {
      URL.revokeObjectURL(pdfUrl);
    }
    setPdfFileState(null);
    setPdfUrlState(null);
  };

  return (
    <FileContext.Provider value={{ pdfFile, setPdfFile, pdfUrl, setPdfUrl, clearPdf }}>
      {children}
    </FileContext.Provider>
  );
}

export function usePdfFile() {
  const context = useContext(FileContext);
  if (context === undefined) {
    throw new Error('usePdfFile must be used within a FileProvider');
  }
  return context;
}
